import React from "react";
import RedeemOutlined from "@mui/icons-material/RedeemOutlined";

import { earnedChipText } from "./format";
import { EarnedChip } from "./styles";
import { ProgressEarnedChipProps } from "./types";

export const ProgressEarnedChip: React.FC<ProgressEarnedChipProps> = ({
  cashbackEarned,
}) => (
  <EarnedChip>
    <RedeemOutlined aria-hidden />
    {earnedChipText(cashbackEarned)}
  </EarnedChip>
);
